module.exports = __webpack_public_path__ + "img/TOP.78bf133d.png";